// Cómo se escribe un medio de pago en pantalla.
//
// No siempre es una tarjeta: Stripe Link no expone `last4` (verificado en el
// primer cobro real, 2026-09-01). Concatenar "••" + last4 a ciegas mostraba
// "link ••null". Una sola función porque lo pintan dos módulos.
export function paymentMethodLabel(brand: string | null, last4: string | null): string | undefined {
  if (!brand && !last4) return undefined;   // DocKV pinta el guion
  if (!last4) return brand ?? undefined;    // Link y otros medios sin tarjeta
  return `${brand ?? ''} ••${last4}`.trim();
}
